import React, { useState, useContext, useEffect  } from "react";
import AuthContext from 'context/AuthProvider';
import Toast from 'light-toast';
import axios from 'axios';
import { API_BASE_URL,SYSTEM_TYPE_AMR_SYSTEMS, SYSTEM_TYPE_AMI_SYSTEMS, SYSTEM_TYPE_REMOTE_CONFIGURATION, SYSTEM_TYPE_AMI_AMR_SYSTEMS } from 'assets/constants/Constants';
import { hasRoutePermission } from "components/Permission";
import { USER_ICON, ROUTE_ICON, SITE_ICON, METER_ICON, USERS_ICON, VCARD_ICON, LINE_CHART_ICON, BAR_ICON, TIMES_CIRCLE_ICON, SIGN_OUT_ICON, BILLING_ICON, SEARCH_ICON, SAFARI_ICON, HISTORY_ICON, CLEAR_ICON, ZONE_SUBZONE_ICON, CONFIG_ICON } from "assets/constants/Icons";
import { ProSidebar, Menu, MenuItem, SidebarHeader, SidebarContent, SidebarFooter, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";

function SideNavigationBar (props) {
    const authContext = useContext(AuthContext);
    const [userDetail, setUserDetail] = useState(JSON.parse(sessionStorage.getItem("userData") || "null"));
    const [userRole, setUserRole] = useState(JSON.parse(sessionStorage.getItem("userRole") || "null"));
    const [systemModule, setSystemModule] = useState(sessionStorage.getItem("systemModule") || "[]");
    const [systemModuleFeature, setSystemModuleFeature] = useState(JSON.parse(sessionStorage.getItem("subModuleFeature") || "[]"));
    const [deviceTypes, setDeviceTypes] = useState(JSON.parse(sessionStorage.getItem("deviceType") || "[]"));
    const [menuCollapse, setMenuCollapse] = useState(true);
    const [showSidebar, setShowSidebar] = useState(false);
    const [amiSystemTypes, setAmiSystemTypes] = useState(JSON.parse(sessionStorage.getItem("ami_amr_remote_system_receiver_type_value") || "[]"))


    useEffect(() => {
        const handleStorageChange = () => {
            setUserDetail(JSON.parse(sessionStorage.getItem("userData") || "null"));
            setUserRole(JSON.parse(sessionStorage.getItem("userRole") || "null"));
            setSystemModule(JSON.parse(sessionStorage.getItem("systemModule") || "[]"));
            setSystemModuleFeature(JSON.parse(sessionStorage.getItem("subModuleFeature") || "[]"));
            setDeviceTypes(JSON.parse(sessionStorage.getItem("deviceType") || "[]"));
            setAmiSystemTypes(JSON.parse(sessionStorage.getItem("amiSystemType") || "[]"))
        };

        // Initial load
        handleStorageChange();
        
        // Listen for storage changes
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('sessionStorageChanged', handleStorageChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('sessionStorageChanged', handleStorageChange);
        };
    }, []);

    const editUserHandler = (userDetail) => {
        props.history.push({
            pathname: "/create-user-page",
            state: { ...userDetail, isFromProfile: true }
        });
    }

    // const getAllMeters = async () => {
    //     return await axios(`${API_BASE_URL}/meter/site/${sessionStorage.getItem("siteId")}`);
    // }

    // const getSiteList = async () => {
    //     return await axios(`${API_BASE_URL}/all/site/${sessionStorage.getItem("siteId")}`);
    // }

    // useEffect(() => {
    //     const fetchMeterData = async () => {
    //         const meterData = await getAllMeters();
    //         setMeterList(meterData.data.result);
    //         const siteData = await getSiteList()
    //         setSiteList(siteData.data.result)
    //     };
    //     fetchMeterData();
    // }, []);

    // const meterTypes = meterList.map(item => item.meter_type);
    // const siteData = siteList.system_type_value


    const menuIconClick = () => {
        const newMenuCollapse = !menuCollapse;
        setMenuCollapse(newMenuCollapse);
        setShowSidebar(!newMenuCollapse); // Show sidebar when not collapsed


        // console.log(authContext.isAuthenticated());
        if (!authContext.isAuthenticated()) {
            Toast.fail('You are not logged in. Please Login!', 3000, () => {
                window.location.href = "/login-page";
            });
        }
    };

    const isAmr = systemModule?.includes(SYSTEM_TYPE_AMR_SYSTEMS);
    const isAmi = systemModule?.includes(SYSTEM_TYPE_AMI_SYSTEMS);
    const isAmiAmr = systemModule?.includes(SYSTEM_TYPE_AMI_AMR_SYSTEMS);
    const isRemote = systemModule?.includes(SYSTEM_TYPE_REMOTE_CONFIGURATION);

    return (
        <div className="side-navigation-bar">
            <div className="side-navigation-bar-hamburger-button" onClick={menuIconClick}>
                { ( menuCollapse ) && ( <span className={`${BAR_ICON} side-navigation-bar-icon`} aria-hidden="true"></span> ) }
                { ( !menuCollapse ) && ( <span className={`${TIMES_CIRCLE_ICON} side-navigation-bar-icon`} aria-hidden="true"></span> ) }
            </div>
            {showSidebar && (
                <div className="side-navigation-bar-content">
                    <ProSidebar collapsed={menuCollapse} breakPoint="md" rtl={false}>
                        <SidebarHeader>
                            { (sessionStorage.getItem("userData") !== null) && (
                                <Menu iconShape="circle">
                                    <MenuItem icon={<i className={`${USER_ICON} side-navigation-bar-icon`}></i>} onClick={ () => editUserHandler(userDetail) } title="Edit user information">
                                        <span>{ `Hi, ${userDetail.first_name} ` }</span>
                                        <span>{ `(${userRole.user_role})` }</span>
                                    </MenuItem>
                                </Menu>
                            )}
                        </SidebarHeader>


                    {/* {(systemModule === SYSTEM_TYPE_AMR_SYSTEMS || systemModule === SYSTEM_TYPE_REMOTE_CONFIGURATION ) && ( */}
                        <React.Fragment>
                            <SidebarContent>
                                <Menu iconShape="square">
                                    {(isAmr || isAmiAmr) && hasRoutePermission("/route-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-route" icon={<i className={`${ROUTE_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Route">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="master-route-page"> Route Master</a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="route-transaction-page">Route Transaction</a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="route-history">Route Collection  History</a>
                                            </MenuItem>
                                        </SubMenu>
                                    )}

                                    {hasRoutePermission("/sites-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-route" icon={<i className={`${CONFIG_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Settings">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="sites-page">Sites</a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="zone-subzone-page">Zones and Subzones</a>
                                            </MenuItem>
                                        </SubMenu>
                                    )}

                                    {hasRoutePermission("/meter-page") ? (
                                        deviceTypes.length > 1 ? (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="meter-page">All Meters</a>
                                                </MenuItem>
                                                {deviceTypes.includes("Flow") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="flow-meter-page">Flow Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Pressure") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="pressure-meter-page">Pressure Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Level") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="level-meter-page">Level Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("OHT Solution") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="oht-meter-page">OHT Meter</a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>
                                        ) : deviceTypes.length === 1 ? (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                {deviceTypes.includes("Flow") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="flow-meter-page">Flow Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Pressure") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="pressure-meter-page">Pressure Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Level") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="level-meter-page">Level Meter</a>
                                                    </MenuItem>
                                                )}
                                                    {deviceTypes.includes("OHT Solution") && (
                                                        <MenuItem>
                                                            <a className="side-navigation-bar-menu-title" href="oht-meter-page">OHT Meter</a>
                                                        </MenuItem>
                                                    )}
                                            </SubMenu>

                                        ) : (
                                            <MenuItem icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                <a className="side-navigation-bar-menu-title" href="meter-page">Meter</a>
                                            </MenuItem>
                                        )
                                    ) : null}

                                    {(isAmr || isAmi || isRemote) &&
                                        hasRoutePermission("/ami-amr-meter-reading-page") && (
                                            <SubMenu
                                                id="side-navigation-bar-sub-menu-billing"
                                                icon={<i className={`${SAFARI_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>}
                                                title="Readings"
                                            >
                                                {(deviceTypes.includes("Flow") && isAmr) && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="ami-amr-meter-reading-page">Ami / Amr Readings</a>
                                                    </MenuItem>
                                                )}
                                                {(deviceTypes.includes("Flow") && isRemote) || (deviceTypes.includes("Flow") && isAmi) && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="flow-readings-page">Flow Readings</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Pressure") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="pressure-readings-page">Pressure Readings</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Level") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="level-readings-page">Level Readings</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("OHT Solution") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="oht-readings-page">OHT Readings</a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>
                                        )}

                                    {hasRoutePermission("/user-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${USERS_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="User">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="user-page"> User Master</a>
                                            </MenuItem>
                                            {hasRoutePermission("/roles-page") && (
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="roles-page">Role</a>
                                                </MenuItem>
                                            )}
                                        </SubMenu>
                                    )}
                                    {systemModuleFeature.includes("Customer Add - Billing Cycle") &&
                                        hasRoutePermission("/customer-page") && (
                                            <MenuItem
                                                icon={<i className={`${VCARD_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>}
                                                title="Customer"
                                            >
                                                <a className="side-navigation-bar-menu-title" href="customer-page">
                                                    Customer
                                                </a>
                                            </MenuItem>
                                        )}

                                    {/* {hasRoutePermission("/report-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-report" icon={<i className={`${LINE_CHART_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Report">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="report-master-page"> Report Master</a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="report-transaction-page">Report Transaction</a>
                                            </MenuItem>
                                        </SubMenu>
                                    )} */}

                                    {systemModuleFeature.includes("Customer Add - Billing Cycle") &&
                                        hasRoutePermission("/billing-cycle-page") && (
                                            <SubMenu id="side-navigation-bar-sub-menu-billing" icon={<i className={`${BILLING_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Billing">
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="billing-setup-page">Billing Setup</a>
                                                </MenuItem>
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="billing-cycle-page">Billing Cycle</a>
                                                </MenuItem>
                                            </SubMenu>
                                        )}

                                    {/* {hasRoutePermission("/sites-page") && (
                                        <MenuItem icon={<i className={`${SEARCH_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Search by Transaction ID">
                                            <a className="side-navigation-bar-menu-title" href="search-transaction-id-page">Search by Transaction ID</a>
                                        </MenuItem>
                                    )} */}

                                    {hasRoutePermission("/meter-history-log") && (
                                        <MenuItem icon={<i style={{ fontStyle: "normal" }} className={`${HISTORY_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter History Log">
                                            <a className="side-navigation-bar-menu-title" href="meter-history-log">Meter History Log</a>
                                        </MenuItem>
                                    )}

                                    {/* { hasRoutePermission( "/clear-meter-history") && (
                                <MenuItem icon={<i style={{fontStyle: "normal"}} className={`${CLEAR_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Clear Meter History">
                                    <a className="side-navigation-bar-menu-title" href="clear-meter-history"> Clear Meter History</a>
                                </MenuItem>
                            )} */}

                                </Menu>
                            </SidebarContent>


                            <SidebarFooter>
                                <Menu>
                                    <MenuItem icon={<i className={`${SIGN_OUT_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Logout" onClick={authContext.signOut}>
                                        <span>Logout</span>
                                    </MenuItem>
                                </Menu>
                            </SidebarFooter>
                        </React.Fragment>


                        {/* <React.Fragment>
                            <SidebarContent>
                                <Menu iconShape="square">

                                    {(hasRoutePermission("/sites-page") && hasRoutePermission("/zone-subzone-page") ) && (
                                        <SubMenu id="side-navigation-bar-sub-menu-route" icon={<i className={`${CONFIG_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Settings">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="sites-page">Sites</a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="zone-subzone-page">Zones and Subzones</a>
                                            </MenuItem>
                                        </SubMenu>
                                    )}

                                       {!hasRoutePermission("/sites-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-route" icon={<i className={`${CONFIG_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Settings">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="zone-subzone-page">Zones and Subzones</a>
                                            </MenuItem>
                                        </SubMenu>
                                    )}

                                    {hasRoutePermission("/meter-page") ? (
                                        deviceTypes.length > 1 ? (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="meter-page">All Meters</a>
                                                </MenuItem>
                                                {deviceTypes.includes("Flow") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="flow-meter-page">Flow Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Pressure") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="pressure-meter-page">Pressure Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Level") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="level-meter-page">Level Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("OHT Solution") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="oht-meter-page">Over Head Tank Meter</a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>
                                        ) : deviceTypes.length === 1 ? (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                {deviceTypes.includes("Flow") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="flow-meter-page">Flow Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Pressure") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="pressure-meter-page">Pressure Meter</a>
                                                    </MenuItem>
                                                )}
                                                {deviceTypes.includes("Level") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="level-meter-page">Level Meter</a>
                                                    </MenuItem>
                                                )}
                                                   {deviceTypes.includes("OHT Solution") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="oht-meter-page">Over Head Tank Meter</a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>

                                        ) : (
                                            <MenuItem icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Meter">
                                                <a className="side-navigation-bar-menu-title" href="meter-page">Meter</a>
                                            </MenuItem>
                                        )
                                    ) : null}

                                    {hasRoutePermission("/ami-amr-meter-reading-page") && (
                                        <SubMenu id="side-navigation-bar-sub-menu-billing" icon={<i className={`${SAFARI_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Readings">
                                            {(deviceTypes.includes("Flow") && amiSystemTypes.includes("Gateway") ) && (
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="ami-amr-meter-reading-page">Ami / Amr Readings</a>
                                                </MenuItem>
                                            )}
                                             {(deviceTypes.includes("Flow") && amiSystemTypes.includes("Mqtt Devices")) && (
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="flow-readings-page">Flow Readings</a>
                                            </MenuItem>
                                             )}
                                            {deviceTypes.includes("Pressure") && (
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="pressure-readings-page">Pressure Readings</a>
                                            </MenuItem>
                                            )}
                                            {deviceTypes.includes("Level") && (
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="level-readings-page">Level Readings</a>
                                            </MenuItem>
                                            )}
                                            {deviceTypes.includes("OHT Solution") && (
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="oht-readings-page">OHT Readings</a>
                                            </MenuItem>
                                            )}
                                        </SubMenu>
                                    )}
                                    {(hasRoutePermission("/user-page") && hasRoutePermission("/roles-page") )  && (
                                        <SubMenu id="side-navigation-bar-sub-menu-user" icon={<i className={`${USERS_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="User">
                                            <MenuItem>
                                                <a className="side-navigation-bar-menu-title" href="user-page"> User Master</a>
                                            </MenuItem>
                                            {hasRoutePermission("/roles-page") && (
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="roles-page">Role</a>
                                                </MenuItem>
                                            )}
                                        </SubMenu>
                                    )}

                                    {systemModuleFeature.includes("Customer Add - Billing Cycle") &&
                                        hasRoutePermission("/customer-page") && (
                                            <MenuItem
                                                icon={<i className={`${VCARD_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>}
                                                title="Customer"
                                            >
                                                <a className="side-navigation-bar-menu-title" href="customer-page">
                                                    Customer
                                                </a>
                                            </MenuItem>
                                        )}

                                    {systemModuleFeature.includes("Customer Add - Billing Cycle") &&
                                        hasRoutePermission("/billing-cycle-page") && (
                                            <SubMenu id="side-navigation-bar-sub-menu-billing" icon={<i className={`${BILLING_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Billing">
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="billing-setup-page">Billing Setup</a>
                                                </MenuItem>
                                                <MenuItem>
                                                    <a className="side-navigation-bar-menu-title" href="billing-cycle-page">Billing Cycle</a>
                                                </MenuItem>
                                            </SubMenu>
                                        )}

                                </Menu>
                            </SidebarContent>


                            <SidebarFooter>
                                 <Menu>
                  <MenuItem
                    icon={
                      <i
                        className={`${SIGN_OUT_ICON} side-navigation-bar-icon`}
                        aria-hidden="true"
                      ></i>
                    }
                    title="Logout"
                    onClick={() => {
                      const confirmLogout = window.confirm(
                        "Are you sure you want to logout?"
                      );
                      if (confirmLogout) {
                        authContext.signOut();
                      }
                    }}
                  >
                    <span>Logout</span>
                  </MenuItem>
                </Menu>
                            </SidebarFooter>
                        </React.Fragment>
                    )} */}
                    </ProSidebar>
                </div>
            )}
        </div>
    );
};

export default SideNavigationBar;
